<template>
  <header>
    <h2>{{ current.title }}</h2>
  </header>
</template>

<script>
export default {
  props: {
    current: Object
  },
  mounted () {
    
  }
}
</script>

<style lang="scss" scoped>
  header {
    width: 100%; padding: $hmg_mid;
    text-align: center; margin-bottom: $hmg_mid;
  }
</style>